import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";

import { selectCustomStyles } from "../../../../lib/constants";
import { api } from "../../../../utils/axios/Config";
import { cn } from "../../../../utils/utils";
import { useDebounce } from "./../../../../hooks/useDebounce";

const SelectCategory = React.memo((props) => {
  const { control, label, name, className, errors, user_id, disabled } = props;

  const [options, setOptions] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const debouncedQueryParams = useDebounce(searchQuery, 1024);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchOptions();
  }, [debouncedQueryParams]);

  const fetchOptions = async () => {
    try {
      const response = await api.get(
        `/businesses/category/?active=true&limit=100&title=${debouncedQueryParams}`,
      );
      const fetchedOptions = response.data.items.map((item) => ({
        value: item?.id,
        label: item?.business_category_code_title,
        id: item?.id,
      }));
      setOptions(fetchedOptions);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const handleInputChange = (newValue) => {
    setSearchQuery(newValue);
    return newValue;
  };

  // Custom component for displaying options
  const CustomOption = ({ innerRef, innerProps, data, isSelected }) => (
    <div
      ref={innerRef}
      {...innerProps}
      className={cn("p-1 hover:bg-neutral-20 cursor-pointer flex gap-2 w-full", {
        "bg-neutral-20": isSelected,
      })}
    >
      <div className="font-semibold">{data.label}</div>
      <hr />
    </div>
  );

  return (
    <div className={cn("col-span-2 xl:col-span-1 flex flex-col gap-2 ", className)}>
      <label htmlFor={name}>{label}</label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => {
          // console.log({value},{options},)
          return (
            <Select
              styles={selectCustomStyles}
              components={{ Option: CustomOption }}
              value={options.find((option) => option.id === value)}
              options={options}
              isDisabled={disabled}
              onInputChange={handleInputChange}
              onChange={(selectedOption) => {
                onChange(selectedOption ? selectedOption.id : null);
              }}
              placeholder="جستجو..."
              isClearable
              isLoading={loading}
              loadingMessage={() => "...در حال دریافت"}
              noOptionsMessage={() => (loading ? "در حال بارگذاری..." : "موردی یافت نشد ...")}
              // formatOptionLabel={(option) => option.id}
            />
          );
        }}
      />
      {errors?.message && <div className="text-red-500 text-sm">{errors?.message}</div>}
    </div>
  );
});

export default SelectCategory;
